"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("react-bootstrap/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconButton = function IconButton(_ref) {
  var noHover = _ref.noHover,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["noHover", "className", "ariaLabel", "children"]);

  var classes = (0, _classnames["default"])(noHover && "btn-uxf-icon-no-hover", className);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    className: classes,
    variant: "uxf-icon",
    "aria-label": ariaLabel
  }, props), children);
};

exports.IconButton = IconButton;
IconButton.propTypes = {
  /**
   * Label for assistive technologies
   */
  ariaLabel: _propTypes["default"].string.isRequired,

  /**
   * Adds the `btn-uxf-icon-no-hover` modifier to remove background-color on hover
   */
  noHover: _propTypes["default"].bool
};
IconButton.defaultProps = {
  noHover: false
};